import {useState} from 'react'

export const useMain = () => {

  const [IngresosTotales, setIngresosTotales]     = useState(0) //* this state is use to save and put the value in the "Ingresos totales" field
  const [SaldoCredito, setSaldoCredito]           = useState(0) //* this is used to calculate the PorcentajeCredito and to put the value in the "Saldo disponible para credito" field

  const fechas = []
  let numero = new Date().getFullYear() - 17
  let contador = numero
  

  while (contador - 100 < numero) {
    fechas.push(numero - 1)
    numero = numero - 1
  }
 
  const [DataDocumentos, setDataDocumentos] = useState({
    CDomicilio_DocName  : '',
    CDomicilio_DocType  : '',
    IFrente_DocName     : '',
    IFrente_DocType     : '',
    IReverso_DocName    : '',
    IReverso_DocType    : '',
    CIngresos_DocName   : '',
    CIngresos_DocType   : ''
    
  })
  
  const [State, setState]   = useState({
    socio                   : true,
    numerosocio             : "",
    apellidopaterno         : "",
    sucursalid              : "",
    apellidomaterno         : "",
    nombre                  : "",
    registrofederal         : "",
    domicilio               : "",
    telefono                : "",
    email                   : "",
    ciudad                  : "",
    estado                  : "GUANAJUATO",
    codigopostal            : "",
    tciudad                 : "",
    tipovivienda            : "",
    tdomicilio              : "",
    casavalue               : 0,
    terrenosvalue           : 0,
    vehiculosvalue          : 0,
    finalidadprestamo       : "",
    aniosexperiencia        : "",
    actividadeconomica      : "",
    estadocivil             : "",
    edad                    : "",
    niveleducacion          : "",
    monto                   : "",
    plazopago               : "",
    frecuenciapago          : "MENSUAL",
    sueldoingreso           : 0,
    otrosingreso            : 0,
    ingresototal            : "", 
    saldodisponiblecredito  : "",
    dianacimiento           : "1",
    mesnacimiento           : "1",
    yearnacimiento          : "", 
    fechanacimiento         : "",
    comprobantedomicilio    : "",
    identificacionfrente    : "",
    identificacionreverso   : "",
    comprobanteingresos     : "",
    curp                    : "",
    colonia                 : "",
    gs_vivienda             : 0,
    gs_entretenimientodig   : 0,
    gs_alimentacion         : 0,
    gs_movil                : 0,
    gs_aseo                 : 0,
    gs_transporte           : 0,
    gs_vehiculo             : 0,
    gs_salud                : 0,
    gs_agua                 : 0,
    gs_entretenimiento      : 0,
    gs_predial              : 0,
    gs_vestimenta           : 0,
    gs_luz                  : 0,
    gs_impuestospension     : 0,
    gs_gas                  : 0,
    gs_otrosgastos          : 0,
  })
  
  const { 
    // socio,
    // numerosocio,
    // apellidopaterno,
    // apellidomaterno,
    // nombre,
    // registrofederal,
    // domicilio,
    // telefono,
    // email,
    // ciudad,
    // estado,
    // codigopostal,
    // tciudad,
    // tipovivienda,
    // tdomicilio,
    // casavalue,
    // terrenosvalue,
    // vehiculosvalue,
    // finalidadprestamo,
    // aniosexperiencia,
    // actividadeconomica,
    // estadocivil,
    // edad,
    // niveleducacion,
    // monto,
    // plazopago,
    sueldoingreso,
    otrosingreso,
    // comprobantedomicilio,
    // identificacionfrente,
    // identificacionreverso,
    // fechanacimiento,
    // comprobanteingresos,
    // curp,
    // colonia              ,
    gs_vivienda          ,
    gs_entretenimientodig,
    gs_alimentacion      ,
    gs_movil             ,
    gs_aseo              ,
    gs_transporte        ,
    gs_vehiculo          ,
    gs_salud             ,
    gs_agua              ,
    gs_entretenimiento   ,
    gs_predial           ,
    gs_vestimenta        ,
    gs_luz               ,
    gs_impuestospension  ,
    gs_gas               ,
    gs_otrosgastos       ,
    // saldodisponiblecredito
  } = State
  


  const totalMoney = () => {
    var valor   = parseFloat(sueldoingreso) + parseFloat(otrosingreso)
    setIngresosTotales(valor.toString()) //* this is to put the value in the input
    
    var calculo = parseFloat(valor) - parseFloat(gs_vivienda          )
    -parseFloat(gs_entretenimientodig)
    -parseFloat(gs_alimentacion      )
    -parseFloat(gs_movil             )
    -parseFloat(gs_aseo              )
    -parseFloat(gs_transporte        )
    -parseFloat(gs_vehiculo          )
    -parseFloat(gs_salud             )
    -parseFloat(gs_agua              )
    -parseFloat(gs_entretenimiento   )
    -parseFloat(gs_predial           )
    -parseFloat(gs_vestimenta        )
    -parseFloat(gs_luz               )
    -parseFloat(gs_impuestospension  )
    -parseFloat(gs_gas               )
    -parseFloat(gs_otrosgastos       )

      var valor2 = calculo.toFixed(2)

      setSaldoCredito((calculo.toFixed(2)))
      setState({
        ...State,
        saldodisponiblecredito: valor2,
        ingresototal: valor
      })
  }

  const handleChange = (event) => { 
    setState({
      ...State,
      [event.target.name] : event.target.value
    })
  };

  const handleChangeLower = (event) => { 
    setState({
      ...State,
      [event.target.name] : event.target.value
    })
  };

  const handleChangeNew = (e, sourceInfo) =>{
    try {
      setState({
        ...State,
        [sourceInfo.event.target.name] : e.value
      })
    } catch (error) {
      console.log(error);
    }
  }
  


  return {
    DataDocumentos,
    State,
    IngresosTotales,
    SaldoCredito,
    totalMoney,
    handleChange,
    handleChangeLower,
    handleChangeNew,
    setState,
    setDataDocumentos,
    fechas
    
  }
}
